<template>
  <el-header class="header">
    <nav style="width: 100%">
      <div class="logo" style="height: 100%">
        <el-link
          :underline="false"
          style="height: 100%; margin-top: 3px; width: 176px"
          @click="HomeClick"
        >
          <img
            src="@/assets/img/erp-login-m.png"
            alt="ERP-Matrix"
            style="height: 100%; width: 100%"
          />
        </el-link>
      </div>
      <div class="nav-bar" style="font-size: 14px">
        <h1
          style="
            margin: 0 auto;
            font-size: 21px;
            font-weight: 700;
            color: rgba(0, 0, 0, 0.6);
            margin-top: 14px;
          "
        >
          <span id="lblTitle"></span>
        </h1>
        <ul class="nav-bar-nav">
          <li class="nav-bar-item">
            <el-dropdown trigger="click" @command="LoginOut">
              <el-button type="text">
                <div style="color: #606266">
                  <el-icon class="el-icon--left">
                    <avatar />
                  </el-icon>
                  <span>{{ getUserName() }}</span>
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </div>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="loginout"
                    >Log out</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </li>
          <li class="nav-bar-item">
            <el-dropdown trigger="click" @command="OpenFolder">
              <el-button type="text" class="nav-button">
                <el-icon>
                  <folder />
                </el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="upgrade"
                    >ERP 更新记录</el-dropdown-item
                  >
                  <el-dropdown-item class="sub-menu-item" command="usermanual"
                    >用户手册</el-dropdown-item
                  >
                  <el-dropdown-item class="sub-menu-item" command="itmanual"
                    >IT開發手冊</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </li>
          <li class="nav-bar-item">
            <div style="min-height: 40px; display: flex; align-items: center">
              <el-badge
                :value="LoginUser.LoginUserTodo"
                class="item"
                type="danger"
              >
                <el-link :underline="false" target="_blank" @click="HomeClick">
                  <el-icon>
                    <BellFilled />
                  </el-icon>
                </el-link>
              </el-badge>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </el-header>
</template>

<script setup>
import './index.css';
import { reactive } from 'vue';
import { ArrowDown, Avatar, Folder, BellFilled } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import router from '@/router/index';
import store from '@/store/index';
import { useAuthorityStore } from '@/store/authority';

const getUserName = () => {
  const useAuthority = useAuthorityStore();
  return useAuthority?.UserInfo?.name || '-';
};

let LoginUser = reactive({
  LoginNickName: store.getters.LoginNickName,
  LoginUserTodo: 0,
});

//跳转到主页
const HomeClick = () => {
  router.replace({
    name: 'report',
  });
};

//登出
const LoginOut = (command) => {
  console.log('logout', command);
  if (command == 'loginout') {
    window.location.href = process.env.VUE_APP_DOMAIN + '/login';
  }
};

//打开文件
const OpenFolder = (command) => {
  if (
    command == 'upgrade' ||
    command == 'usermanual' ||
    command == 'itmanual'
  ) {
    ElMessage({
      message: '开发中...',
      type: 'warning',
    });
  }
};
</script>
